module.exports = __webpack_public_path__ + "img/vipBack.05959238.png";